import { axiosErrorToast } from '@campx-org/shared'
import Cookies from 'js-cookie'
import { urlTenantKey } from 'components/Providers'
import axios from 'utils/axios'

export default function logout() {
  axios({
    method: 'POST',
    baseURL: process.env.REACT_APP_API_HOST,
    url: '/auth-server/auth/evaluator-logout',
  })
    .then((res) => {
      Cookies.remove('campx_session_key')
      Cookies.remove('campx_evaluator_key')
      Cookies.remove('campx_tenant')
      window.location.href = `${window.location.origin}/${urlTenantKey}`
    })
    .catch((err) => {
      axiosErrorToast('Unable To Logout.')
    })
}
